import { Rocket, Map, BookOpen, FileText, Camera } from "lucide-react";

// Honest roadmap. These are being built, not live yet. Labelled as such.
const UPCOMING = [
  { icon: <Map size={16} />, title: "A living roadmap", body: "Your roadmap with real status, gentle accountability, and reminders, so a plan actually moves instead of just sitting there.", tag: "building" },
  { icon: <BookOpen size={16} />, title: "Learning worth opening", body: "Book picks matched to you, short reads, and a way to track what you have started, all in one place.", tag: "building" },
  { icon: <FileText size={16} />, title: "Resume that fills itself", body: "Your resume drafted from what you have already told Klair, ready to share or download as a PDF.", tag: "building" },
  { icon: <Camera size={16} />, title: "Profile photo", body: "Add a photo once and it flows onto your resume automatically.", tag: "next" },
];

/**
 * Upcoming. What we are building next, kept honest. Nothing here claims
 * to be live. When one ships, it moves to What's new.
 */
export default function UpcomingScreen() {
  return (
    <div className="max-w-3xl mx-auto px-5 pt-8 pb-24">
      <div className="k-label mb-2 flex items-center gap-2"><Rocket size={13} /> upcoming</div>
      <h1 className="klareet-serif mb-2" style={{ fontSize: "clamp(1.8rem, 4vw, 2.4rem)", lineHeight: 1.1 }} data-testid="upcoming-title">
        What we're building next.
      </h1>
      <p className="k-hero-sub mb-6">A peek at what is coming. These are in progress, not live yet.</p>

      <div className="space-y-4" data-testid="upcoming-list">
        {UPCOMING.map((u, i) => (
          <div key={i} className="k-card flex items-start gap-3" data-testid={`upcoming-item-${i}`}>
            <span className="k-chip mt-0.5">{u.icon}</span>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <div className="font-semibold" style={{ color: "hsl(var(--klareet-ink))" }}>{u.title}</div>
                <span className="k-chip !text-[10px]">{u.tag}</span>
              </div>
              <p className="text-sm mt-1" style={{ color: "hsl(var(--klareet-ink-soft))", lineHeight: 1.6 }}>{u.body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
